export const API_BASE_URL = {
  test: 'https://api-test.retaintive.ai',
  pre: 'https://api-pre.retaintive.ai',
  prod: 'https://api.retaintive.ai',
};

export const USER_POOL_SETTINGS = {
  test: {
    userPoolId: 'us-east-1_plb8u3yrz',
    userPoolClientId: 'g5skfq4amcah809quuafuq6a0',
  },
  pre: {
    userPoolId: 'us-east-1_plb8u3yrz',
    userPoolClientId: 'g5skfq4amcah809quuafuq6a0',
  },
  prod: {
    userPoolId: 'us-east-1_uyKPkGOy4',
    userPoolClientId: '297pj4kkpn2qi0reufrkggms18',
  },
};
